module.exports = __webpack_public_path__ + "img/matic.245b1f73.svg";